<template>
  <div class="coupon__item select">
    <div class="coupon__item__top">
      <div class="vertical-align" style="height:48px">
        <span class="coupon__item__top__unit">¥</span>
        <span class="coupon__item__top__money middle">{{ coupon.couponAward }}</span>
      </div>
      <div class="coupon__item__top__desc">{{ coupon.couponName }}</div>
    </div>
    <div class="coupon__item__bottom pointer" @click="$emit('click')">
      {{ couponStatus[coupon.couponReceiveStatus] }}
    </div>
  </div>
</template>

<script>
import { couponStatus } from '@/const/index';
export default {
  props: {
    coupon: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      couponStatus
    };
  }
};
</script>

<style lang="scss" scoped>
.coupon__item {
  position: relative;
  width: 200px;
  height: 140px;
  padding: 16px 0;
  border-radius: 8px;
  background: url('../../../../assets/img/coupon.png') no-repeat center/100% 100%;
  &__top {
    margin: 0 12px;
    text-align: center;
    &__unit {
      margin-right: 4px;
      font-size: 20px;
      font-weight: 500;
      color: #ff4e47;
      line-height: 1;
      vertical-align: bottom;
    }
    &__money {
      display: inline-block;
      height: 48px;
      max-width: 160px;
      font-size: 48px;
      font-weight: 600;
      color: #ff4e47;
      line-height: 1;
      word-break: break-all;
      overflow: hidden;
    }
    &__desc {
      margin-top: 2px;
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      line-height: 1;
    }
  }
  &__bottom {
    display: inline-block;
    width: 120px;
    height: 26px;
    position: absolute;
    left: 0;
    right: 0;
    margin: 18px auto auto auto;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    color: #ff4e47;
    line-height: 26px;
    background: #fff1f1;
    border-radius: 13px;
  }
  & + .coupon__item {
    margin-left: 32px;
  }
}
// .coupon__item {
//   position: relative;
//   width: 200px;
//   height: 140px;
//   background: linear-gradient(134deg, #fb6449 0%, #ff6144 43%, #fb9984 100%);
//   border-radius: 8px;
//   &__content {
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     transform: translate(-50%, -50%);
//     width: 184px;
//     height: 124px;
//     background: #ffffff;
//     &__top {
//       padding: 8px 0;
//       margin: 0 12px;
//       text-align: center;
//       border-bottom: 1px dashed #ff4e47;
//       &__unit {
//         margin-right: 4px;
//         font-size: 20px;
//         font-weight: 500;
//         color: #ff4e47;
//         line-height: 1;
//       }
//       &__money {
//         font-size: 48px;
//         font-weight: 600;
//         color: #ff4e47;
//         line-height: 1;
//       }
//       &__desc {
//         margin-top: 2px;
//         font-size: 12px;
//         font-weight: 400;
//         color: #595959;
//         line-height: 1;
//       }
//     }
//     &__bottom {
//       display: inline-block;
//       width: 120px;
//       height: 26px;
//       position: absolute;
//       left: 0;
//       right: 0;
//       margin: 10px auto auto auto;
//       font-size: 18px;
//       font-weight: 500;
//       text-align: center;
//       color: #ff4e47;
//       line-height: 26px;
//       background: #fff1f1;
//       border-radius: 13px;
//     }
//   }
//   .point {
//     position: absolute;
//     bottom: 38px;
//     width: 8px;
//     height: 16px;
//     background: linear-gradient(134deg, #fb6449 0%, #ff6144 43%, #fb9984 100%);
//     &__left {
//       border-radius: 0 16px 16px 0;
//       left: -1px;
//     }
//     &__right {
//       border-radius: 16px 0 0 16px;
//       right: -1px;
//     }
//   }
//   & + .coupon__item {
//     margin-left: 32px;
//   }
// }
</style>
